import React from 'react';
import './Loader.css';

const LoaderCircle = () => {
    return (
        <div className="overlay">
            <div className="loader"></div>
        </div>
    );
};

export default LoaderCircle;